import { render, staticRenderFns } from "./SpeedGauge.vue?vue&type=template&id=53e8acbf&scoped=true&"
import script from "./SpeedGauge.vue?vue&type=script&lang=ts&"
export * from "./SpeedGauge.vue?vue&type=script&lang=ts&"
import style0 from "./SpeedGauge.vue?vue&type=style&index=0&id=53e8acbf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e8acbf",
  null
  
)

export default component.exports